import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { restaurantConfig } from "../config/restaurantConfig";

export default function Footer() {
  const { brand, contact, social, hours, ui } = restaurantConfig;
  const f = ui.footer;
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-zinc-800/80 dark:bg-zinc-950 bg-[#F5F2EA] mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Brand */}
        <div>
          <div className="mb-5">
            <img
              src={brand.logo}
              alt={brand.logoAlt}
              className="h-16 w-auto object-contain dark:brightness-110"
              draggable={false}
            />
          </div>
          <p className="text-sm text-zinc-700 dark:text-zinc-300 max-w-xs leading-relaxed font-sans font-light">
            {brand.descriptor}
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a
              href={social.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-zinc-700/50 dark:border-zinc-700 text-zinc-700 dark:text-zinc-300 hover:border-burgundy hover:bg-burgundy hover:text-white hover:scale-110 transition-all duration-300"
            >
              <Facebook className="w-3.5 h-3.5" strokeWidth={1.5} />
            </a>
            <a
              href={social.instagram}
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-zinc-700/50 dark:border-zinc-700 text-zinc-700 dark:text-zinc-300 hover:border-burgundy hover:bg-burgundy hover:text-white hover:scale-110 transition-all duration-300"
            >
              <Instagram className="w-3.5 h-3.5" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-[11px] tracking-luxe uppercase text-burgundy dark:text-gold mb-5 font-sans">{f.contactTitle}</h4>
          <ul className="space-y-3 text-sm font-sans">
            <li className="flex items-start gap-3 text-zinc-800 dark:text-zinc-200">
              <MapPin className="w-4 h-4 mt-0.5 text-burgundy dark:text-gold flex-shrink-0" strokeWidth={1.5} />
              <span>{contact.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-burgundy dark:text-gold" strokeWidth={1.5} />
              <a
                href={contact.phoneLink}
                data-testid="footer-phone"
                className="text-zinc-800 dark:text-zinc-200 hover:text-burgundy dark:hover:text-gold transition-colors duration-300"
              >
                {contact.phoneDisplay}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-burgundy dark:text-gold" strokeWidth={1.5} />
              <a
                href={`mailto:${contact.email}`}
                className="text-zinc-800 dark:text-zinc-200 hover:text-burgundy dark:hover:text-gold transition-colors duration-300 break-all"
              >
                {contact.email}
              </a>
            </li>
          </ul>
        </div>

        {/* Hours */}
        <div>
          <h4 className="text-[11px] tracking-luxe uppercase text-burgundy dark:text-gold mb-5 font-sans">{f.hoursTitle}</h4>
          <ul className="space-y-2.5 text-sm font-sans">
            {hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span className="text-zinc-900 dark:text-zinc-100 w-24 font-medium">{h.day}</span>
                <span className="text-zinc-600 dark:text-zinc-400 text-right flex-1 font-light">{h.service}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-300/70 dark:border-zinc-800">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-3 items-center justify-between">
          <p className="text-[11px] tracking-luxe-sm uppercase text-zinc-600 dark:text-zinc-400 font-sans">
            © {new Date().getFullYear()} {brand.name}. {f.copyright}
          </p>
          <div className="flex items-center gap-6 text-[11px] tracking-luxe-sm uppercase text-zinc-600 dark:text-zinc-400 font-sans">
            {f.links.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-burgundy dark:hover:text-gold transition-colors duration-300">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
